import { useCallback, useState } from "react";
import { useNotification } from "../../../../hooks/useNotification";
import {
  useGetFulfilmentStepQuery,
  useRunFulfilmentStepMutation,
} from "../../../../store/apiSlice/salesFulfilmentApiSlice";
import { stepErrorMessage } from "./fulfilHelpers";

const NO_LINES = [];
const NO_DEFAULTS = {};

/**
 * Loads what one Fulfil step can act on for this order, and runs the step.
 * Keeps the last result so the panel can show what happened.
 *
 * @param {(string|number)} orderId
 * @param {string} step allocate, pick-list, pick, pack, ship or invoice.
 */
export const useFulfilStep = (orderId, step) => {
  const notify = useNotification();
  const query = useGetFulfilmentStepQuery({ orderId, step }, { refetchOnMountOrArgChange: true });
  const [runStep, { isLoading: saving }] = useRunFulfilmentStepMutation();
  const [result, setResult] = useState(null);

  const run = useCallback(
    async body => {
      try {
        const response = await runStep({ orderId, step, body }).unwrap();
        setResult(response);
        return response;
      } catch (error) {
        notify({ type: "error", message: stepErrorMessage(error) });
        return null;
      }
    },
    [notify, orderId, runStep, step],
  );

  const clearResult = useCallback(() => setResult(null), []);

  return {
    query,
    rows: query.data?.lines || NO_LINES,
    defaults: query.data?.defaults || NO_DEFAULTS,
    run,
    saving,
    result,
    clearResult,
  };
};
